<kendo-multiselect [data]="data" [(ngModel)]="selected" [valuePrimitive]="valuePrimitive" [textField]="textField" [valueField]="valueField">
</kendo-multiselect>
